import React, {Component} from "react";
import {withNamespaces} from "react-i18next";
import BreadcrumbExtend from "../../../components/BreadcrumbExtend";
import SettingTable from "./_components/SettingTable";
import {connect} from "react-redux";
import {settingAction} from "../../../actions/setting.actions";

class SettingPage extends Component {

    state = {
        selectedItem: null
    };

    componentDidMount() {
        const { dispatch } = this.props;
        dispatch(settingAction.getConfigList());
    }

    handleSelected = (data) => {
        if(data !== null) {
            this.setState({
                ...this.state,
                selectedItem: data
            });
        } else {
            this.setState({
                ...this.state,
                selectedItem: null
            })
        }
    };

    handleOnChangeInput = (e) => {
        this.setState({
            ...this.state,
            selectedItem: {
                ...this.state.selectedItem,
                [e.target.name]: e.target.value
            }
        });
    };

    handleOnSubmit = (e) => {
        e.preventDefault();
        const { dispatch } = this.props;
        dispatch(settingAction.editConfig(this.state.selectedItem));
    };

    render() {
        const { t, configList } = this.props;

        const breadcrumb = [
            { value: 'settings', path: '#' }
        ];

        return(
            <div>
                <BreadcrumbExtend items={breadcrumb}/>
                <h4>{ t('settings') }</h4>
                <div className="card">
                    <div className="card-body row">
                        <div className="col-md-8">
                            <SettingTable list={configList} getSelected={this.handleSelected} />
                        </div>
                        <div className="col-md-4 border-left">
                            {this.state.selectedItem ? (
                                    <form onSubmit={this.handleOnSubmit}>
                                        <div className="form-group ">
                                            <label className="col-form-label" > {t('key')} </label>
                                            <input
                                                type="text"
                                                className="form-control"
                                                name="key"
                                                readOnly
                                                value={this.state.selectedItem.key}
                                                disabled />
                                        </div>
                                        <div className="form-group ">
                                            <label className="col-form-label"> {t('value')} </label>
                                            <input
                                                type="text"
                                                className="form-control"
                                                name="value"
                                                value={this.state.selectedItem.value}
                                                onChange={this.handleOnChangeInput}
                                            />
                                        </div>

                                        <div className="form-group mt-5">
                                            <button type="submit" className="btn btn-primary mx-1">
                                                <i className="fas fa-edit" /> &nbsp; {t('save')}
                                            </button>
                                        </div>

                                    </form>
                            ) : (
                                <div className="text-center p-4">
                                    <h3>{ t('settings-no-click') }</h3>
                                    <p>{ t('click-row') }</p>
                                </div>
                            )}
                        </div>

                    </div>
                </div>
            </div>
        )
    }
}
const mapStateToProps = (state) => {
    const {configList} = state.settingReducer;
    return {
        configList
    }
};
export default withNamespaces()(connect(mapStateToProps)(SettingPage));
